<template>
  <div>
    <v-dialog v-model="logoutDialog" max-width="290">
      <Logout @closeLogoutDialog="logoutDialog = false" />
    </v-dialog>

    <v-overlay :value="overlay"
      ><v-progress-circular indeterminate size="64"></v-progress-circular
    ></v-overlay>

    <router-view @showLogoutDialog="logoutDialog = true" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Logout } from "@/components/organizer";

export default {
  components: { Logout },

  data: () => ({
    logoutDialog: false,
    overlay: false,
  }),

  methods: {
    ...mapActions(["makeFetch"]),
  },

  computed: {
    polls() {
      return this.$store.getters.getCollection("polls");
    },
  },

  async mounted() {
    if (["Create", "Start"].includes(this.$route.name)) return;

    this.overlay = true;
    const res = await this.makeFetch({
      method: "get",
      goTo: "/polls",
      stateVar: "polls",
    })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.overlay = false;
      });

    if (res && res.success) {
      const hasId = !!this.$route.params.id; // !! converts to boolean
      if (hasId) return;

      const { data } = res;

      if (data.length > 0) {
        this.$router.push({ name: "Manage", params: { id: data[0].id } });
      } else {
        this.$router.push({ name: "Start" });
      }
    }
  },
};
</script>
